import { UnitType } from '@exodus/currency'

const name = 'kava'
const displayName = 'Kava'
const ticker = 'KAVA'
const displayTicker = 'KAVA'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#FF433E'
const gradientColors = ['#FF433E', '#EF8534']
const gradientCoords = { x1: '37%', y1: '39%', x2: '-1.155%', y2: '4.911%' }
const chainBadgeColors = gradientColors

const units = {
  ukava: 0,
  KAVA: 6,
}

const currency = UnitType.create(units)

const assetType = 'COSMOS_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://www.mintscan.io/kava/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://www.mintscan.io/kava/txs/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'KAVA is the native utility and governance token for Kava, a blockchain with unique co-chain architecture that uses Cosmos and Ethereum together to offer high speeds, interoperability, scalability, and familiar tooling for developers.',
  reddit: 'https://reddit.com/r/kava_platform/',
  twitter: 'https://twitter.com/KAVA_CHAIN',
  website: 'https://www.kava.io',
  telegram: 'https://t.me/kavalabs',
  discord: 'https://discord.com/invite/q6QuanE4bx',
  medium: 'https://medium.com/kava-labs',
}

export const asset = {
  assetType,
  baseAssetName,
  baseDenom: 'ukava',
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
